import { Empty } from '@phosphor-icons/react';

const NoDataFound = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-4 py-12">
      <div className="flex w-full max-w-lg flex-col items-center gap-6 rounded-2xl border border-gray-200 bg-white px-8 py-10 shadow-sm">
        <div className="relative flex items-center justify-center">
          <span className="absolute inline-flex h-24 w-24 rounded-full bg-slate-100/70" />
          <span className="relative inline-flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-slate-100 to-slate-200 text-brandSecondary ring-8 ring-slate-50">
            <Empty size={34} />
          </span>
        </div>

        <div className="flex w-full flex-col items-center gap-2 text-center">
          <h2 className="text-xl font-semibold text-brandSecondary">
            No Records Found
          </h2>
          <p className="text-sm text-gray-500">
            There&rsquo;s nothing to show here yet.
          </p>
        </div>

        <div className="w-full overflow-hidden rounded-xl border-2 border-slate-300 shadow-sm">
          <table className="w-full border-collapse text-left text-sm">
            <thead>
              <tr className="bg-slate-100">
                <th
                  className="border-b-2 border-r border-slate-300 px-4 py-3 text-xs font-bold uppercase tracking-wide text-brandSecondary"
                  scope="col"
                >
                  Why this might happen
                </th>
                <th
                  className="border-b-2 border-slate-300 px-4 py-3 text-xs font-bold uppercase tracking-wide text-brandSecondary"
                  scope="col"
                >
                  What you can do
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white">
                <td className="border-b border-r border-slate-200 px-4 py-3.5 align-top text-gray-700">
                  No matching records have been created yet.
                </td>
                <td className="border-b border-slate-200 px-4 py-3.5 align-top font-medium text-gray-800">
                  Add a new record to get started.
                </td>
              </tr>
              <tr className="bg-slate-50">
                <td className="border-b border-r border-slate-200 px-4 py-3.5 align-top text-gray-700">
                  The filters you applied don&rsquo;t match any items.
                </td>
                <td className="border-b border-slate-200 px-4 py-3.5 align-top font-medium text-gray-800">
                  Adjust or clear your filters and try again.
                </td>
              </tr>
              <tr className="bg-white">
                <td className="border-r border-slate-200 px-4 py-3.5 align-top text-gray-700">
                  You may not be authorized to view these records.
                </td>
                <td className="px-4 py-3.5 align-top font-medium text-gray-800">
                  Get in touch with your team to figure out the right access
                  level.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default NoDataFound;
